window.Blimp = window.Blimp || {};

class PhotoView extends Backbone.View {
  get tagName() {
    return 'a';
  }

  get className() {
    return 'photo';
  }

  get events() {
    return {
      'click': 'zoom'
    };
  }

  initialize() {
    this.zoom = this.zoom.bind(this);
    this.listenTo(this.model, 'remove', () => {
      this.trigger('remove', this);
      this.remove();
    });
  }

  render() {
    this.$el.attr('href', `${this.model.url()}`);
    this.$el.css('background-image', `url(${this.model.thumb_url()})`);
    if (this.model.is_video()) {
      this.$el.append('<div class="play-video-icon-wrapper"><i class="play-video-icon fa fa-play-circle"></i></div>');
    }
    return this;
  }

  zoom() {
    Blimp.zoom_view.return_url = Backbone.history.getFragment();
    Blimp.app.navigate(`${this.model.url()}`, { trigger: true });
    return false;
  }
}

Blimp.PhotoView = PhotoView;
